import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopy, Check } from "@mui/icons-material";

export const DOMAIN = "https://drpawleb.com";

export const PAGE_LINKS = [
  { label: "Home",     path: "/",                   desc: "Main landing page" },
  { label: "Courses",  path: "/membership/classes",  desc: "All courses & learning" },
  { label: "Pricing",  path: "/#pricing",            desc: "Home page pricing plans" },
  { label: "Login",    path: "/login",               desc: "User login" },
  { label: "Sign Up",  path: "/signup",              desc: "New user registration" },
];

export const uid = () => Math.random().toString(36).slice(2, 9);

export function CopyButton({ text, small }: { text: string; small?: boolean }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <Tooltip title={copied ? "Copied!" : "Copy"}>
      <IconButton
        size="small"
        onClick={handleCopy}
        sx={{
          color: copied ? "#22C55E" : "#1565C0",
          bgcolor: copied ? "rgba(34,197,94,.1)" : "rgba(21,101,192,.08)",
          "&:hover": { bgcolor: copied ? "rgba(34,197,94,.15)" : "rgba(21,101,192,.15)" },
          borderRadius: "8px",
          ...(small ? { width: 28, height: 28 } : {}),
        }}
      >
        {copied ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
